<template>
  <section class="icon-button-wrapper">
    <span v-if="hasCountBadge" class="icon-button__counter">{{ displayedCount }}</span>
    <button
      :class="['icon-button', colorClass, { 'icon-button--active': active }]"
      @click="handleClick"
      :title="title"
      :aria-label="title"
    >
      <component :is="IconComponent" />
    </button>
  </section>
</template>

<script>
import "./IconButton.css";

export default {
  name: "IconButton",

  props: {
    title: {
      type: String,
      default: "",
    },
    icon: {
      type: String,
      required: true,
      validator(value) {
        return ["camera", "camera-switch", "microphone", "chat", "call"].includes(value);
      },
    },
    color: {
      type: String,
      default: null,
      validator(value) {
        return ["red", "green", null].includes(value);
      },
    },
    initialActive: {
      type: Boolean,
      default: true,
    },
    count: {
      type: Number,
      default: 0
    },
    toggleOnClick: {
      type: Boolean,
      default: true
    }
  },

  data() {
    return {
      active: this.initialActive,
    };
  },

  watch: {
    initialActive(value) {
      this.active = value;
    },
  },

  computed: {
    hasCountBadge() {
      return this.count > 0
    },
    displayedCount() {
      return this.count > 99 ? '99+' : this.count
    },
    colorClass() {
      if (
        (this.icon === "camera" || this.icon === "microphone") &&
        !this.active
      ) {
        return "icon-button--color-red";
      }
      switch (this.color) {
        case "red":
          return "icon-button--color-red";
        case "green":
          return "icon-button--color-green";
        default:
          return "";
      }
    },
    IconComponent() {
      const map = {
        camera: this.active
          ? require("../icons/IconCamera.vue").default
          : require("../icons/IconCameraSlash.vue").default,
        "camera-switch": require("../icons/IconCameraSwitch.vue").default,
        microphone: this.active
          ? require("../icons/IconMicrophone.vue").default
          : require("../icons/IconMicrophoneSlash.vue").default,
        chat: require("../icons/IconChat.vue").default,
        call: require("../icons/IconCall.vue").default,
      };

      return map[this.icon] || null;
    },
  },

  methods: {
    handleClick() {
      if (this.toggleOnClick) {
        this.active = !this.active;
      }
      this.$emit("toggle", this.active);
    },
  },
};
</script>
